<div class="overlay">
  <img src="logo.png">
</div>
